export default __webpack_public_path__ + "a2b983b97046a8b39a8ec4acf7ff821b.png";